require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()

require("js-cookie")
require("sortablejs")
require("jquery-toast-plugin")
require('blueimp-load-image/js/load-image');
require('bootstrap')
require('bootstrap-datepicker/dist/js/bootstrap-datepicker')
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.ja.min')
require('select2/dist/js/select2')
require('admin-lte/plugins/bootstrap-switch/js/bootstrap-switch')
require('admin-lte/plugins/overlayScrollbars/js/jquery.overlayScrollbars')
require('admin-lte/build/js/AdminLTE')
window.jQuery = jQuery;

require("../stylesheets/admin/admin.scss")
require("../stylesheets/admin/seminar.scss")

require("../src/admin/init")
require("../src/admin/common")
require("../src/admin/images")
require("../src/admin/seminar")
require("../src/admin/seminar_applicant")

global.jQuery, global.$ = require("jquery");